import { useDeviceType } from '@picsart/design-system/hooks/device';
import useOpen from '@/hooks/useOpen';
import AppContent from '@/components/AppContent';
import { isMobile } from '@/consts/device';

import '@/utils/dev/logger';

export const App = () => {
  const isOpen = useOpen();
  const { isMobile: isMobileDeviceType } = useDeviceType();

  // eslint-disable-next-line no-console
  console.log('isMobile', {
    'design system useDeviceType': { isMobile: isMobileDeviceType },
    'design system getDeviceType': { isMobile },
  });

  if (!isOpen) {
    return null;
  }

  return <AppContent />;
};

export default App;
